export default __webpack_public_path__ + "static/template-about-history-background-b1558ca38840c7f20942fa66654d550e.jpg";